module.exports = __webpack_public_path__ + "assets/img/img-detail-bottom-sp.d9937869.jpg";